import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { useFormFieldContext } from '../../hooks/useFormFieldContext.js';
import '../../../ValidationMessage/index.js';
import { ValidationMessageComponent } from '../../../ValidationMessage/ValidationMessage.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ValidationMessage = /*#__PURE__*/React.memo(function (props) {
  var _useFormFieldContext = useFormFieldContext(),
    id = _useFormFieldContext.validationMessageId,
    state = _useFormFieldContext.state;
  return ValidationMessageComponent(_objectSpread({
    id: id,
    state: state
  }, props));
});
ValidationMessage.displayName = 'FormField.ValidationMessage';

export { ValidationMessage };
//# sourceMappingURL=ValidationMessage.js.map
